import { createTheme, PaletteColorOptions } from "@mui/material";

export const palette = {
  primary: {
    main: "#99a24d",
  },
  background: {
    default: "#efede6",
  },
  text: { primary: "#333333" },
  selectedButton: {
    main: "#e0e7d4",
  },
  unselectedButton: {
    main: "#0000",
  },
};

const theme = createTheme({
  palette,
  components: {
    MuiButton: {
      styleOverrides: {
        outlined: {
          borderWidth: 2,
          "&:hover": {
            borderWidth: 2,
          },
        },
      },
    },
  },
});

export default theme;

declare module "@mui/material/styles/createPalette" {
  interface PaletteOptions {
    selectedButton?: PaletteColorOptions;
    unselectedButton?: PaletteColorOptions;
  }
}
declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    selectedButton: true;
    unselectedButton: true;
  }
}
